export enum ProductVersion {
  HOUSE_VERSION = '08.16,2',
  FLAT_VERSION = '08.15,2',
  NS_VERSION = '02.09,1',
  PETS_VERSION = '00.04,1',
  SPORT_VERSION = '02.13,1',
  MITE_VERSION = '00.05,1',
  TRAVEL_VERSION = '03.08,1',
}
